import React from 'react'

export default function LastGoodPoint(props) {
    return (
        <div className="col-md col-12 mt-md-0 mt-2 feature d-flex flex-column justify-content-center align-items-center">
            <img src={props.img} alt="Experience Of Years" />
            <h6 className='mt-1 text-center'>{props.title}</h6>
        </div>
    )
}
